module.exports = __webpack_public_path__ + "static/img/nftLoop.326bd24.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nftLoop.gif
// module id = B0l7
// module chunks = 1